import { Component, OnInit, ViewChild } from '@angular/core';
import * as _ from 'lodash';
import { Moment } from 'moment';
import * as moment from 'moment';
import { LazyLoadEvent } from 'primeng/components/common/lazyloadevent';
import { DataTable } from 'primeng/primeng';

import { PaymentFile } from '../../models/paymentFile.model';
import { AuthorizationService } from '../../services/authorization.service';
import { CalendarService } from '../../services/calendar-api.service';
import { DepositService } from '../../services/deposit-api.service';
import { DepositSettingsService } from '../../services/depositSettings-api.service';
import { GlobalFilterService } from '../../services/global-filter.service';
import { DepositTableHelper } from './confirm-deposit.tableHelper';

const DEPOSIT_CONFIRMATION = 'DC'
@Component({
  selector: 'app-deposits',
  templateUrl: './confirm-deposit.component.html',
  styleUrls: ['./confirm-deposit.component.css'],
})

export class ConfirmDepositComponent implements OnInit {
  public readonly DATE_FORMAT = 'YYYY-MM-DD'
  public readonly DAYS_IN_FUTURE = 7

  public readonly Row_Limit: number = 15
  public unpostedDeposits: PaymentFile[]
  public offset: number
  public totalItemCount: number
  public formValid: boolean
  public readonly tableHelper: DepositTableHelper
  public totalRecords: number
  public loadingStatus: boolean
  public buttonRollup: boolean
  public validationError = false
  public display = false
  public dateValidation: number
  public mobile: boolean = window.screen.availWidth <= 375 ? true : false
  public viewState  = false
  public clientId: string
  public disableStatus = 'AVAILABLE'
  public lastCloseDate: Date

  @ViewChild('dt') dataTable: DataTable;

  constructor(private authorizationService: AuthorizationService,
              private globalFilterService: GlobalFilterService,
              private depositService: DepositService,
              private depositSettingsService: DepositSettingsService,
              private calendarService: CalendarService) {
    this.tableHelper = new DepositTableHelper()
  }

 clientInfoChanged() {
    this.updateNotify()
    this.resetForm()
    if (this.globalFilterService.selectedEnvironment) {
      this.clientId = this.globalFilterService.selectedEnvironment.ClientId4Digit
    } else {
      return
    }
    this.dataTable.reset()
    this.depositSettingsService.getDepositSettings(this.clientId).then( () => {
      let value: any = this.depositSettingsService.currentDepositSettings.Settings.DepositOption
      this.viewState = value === DEPOSIT_CONFIRMATION ? true : false
      this.tableHelper.PotentialDepositColumns[0].show = this.viewState
    })
    this.calendarService.getLastCloseDate(this.clientId).then( (lcd: Date) => {
      if (moment(lcd, this.DATE_FORMAT).isValid()) {
        this.lastCloseDate = moment(lcd, this.DATE_FORMAT).toDate()
      } else {
        this.lastCloseDate = moment().toDate()
      }
    })
  }

  async loadDepositsLazy(event: LazyLoadEvent, initialLoad: boolean) {
    this.updateNotify()
    this.loadingStatus = true
    if (initialLoad) {
      this.unpostedDeposits = null
    }

    if (this.clientId) {
      await this.getUnpostedPaymentFiles(event.first, event.sortField, event.sortOrder)
    }
  }

  async getUnpostedPaymentFiles(offset: number, sort: string, sortOrder: number, limit: number = this.Row_Limit): Promise<void> {
    await this.depositService.getUnpostedPaymentFiles<PaymentFile>(this.clientId, limit, offset, sort, sortOrder)
      .then( (data) => {
        this.unpostedDeposits = []
        this.unpostedDeposits =  data.Items
        this.offset = data.Offset
        this.totalItemCount = data.TotalItemCount
        this.loadingStatus = false
        this.display = false
        this.validateCheckDates(this.unpostedDeposits)
        this.loadingStatus = false
      })
      .catch( () => {
        this.loadingStatus = false
        this.display = false
        this.loadingStatus = false
      })
    this.formValid = false
  }

  resetForm() {
    this.formValid = false
    this.dateValidation = 0
    this.validationError = false
  }

  async postPaymentFilesForDeposit() {
    this.updateNotify()
    let selectedData: PaymentFile[] = []
    let groups = _.groupBy(this.dataTable.value, 'status')
    if (groups.true) {
      selectedData = groups.true
    }

    await this.depositService.postToPaymentFileQueue(this.clientId, selectedData)
      .then( (data) => {
        if (data) {
          this.dataTable.reset()
          this.statusRollup()
        }
      })
      .catch( () => {

      })
  }

  addRowStyle(rowData: any) {
    if (rowData.disabled) {
      return 'rowWarn'
    } else if (rowData.RawDataImport_DepositQueueStatus && rowData.RawDataImport_DepositQueueStatus.trim() === 'ERROR') {
      return 'rowAlert'
    }
  }

  statusRollup() {
    this.updateNotify()
    if (this.dataTable.value) {
      if (_.find(this.dataTable.value, {status: true})) {
        this.formValid = true
      } else {
        this.formValid = false
      }

      if (_.find(this.dataTable.value, {status: true, disabled: true})) {
        this.formValid = false
        return
      }
    }
  }

  validation(event, dataRow, rowIndex) {
    this.dateValidation = this.validateDate(dataRow.Check_CheckDate)
    this.validateCheckDates(this.dataTable.value)
    if (!this.formValid && this.dateValidation !== 0) {
      this.validationError = true
    } else {
      this.validationError = false
    }

    this.statusRollup()
  }

  validateDate(value: any): number {
    let valueState: Moment = moment(value)
    if (!moment(value, 'MM/DD/YYYY').isValid() || value === undefined) {
      return 1
    } else if (valueState > moment(this.lastCloseDate).add(this.DAYS_IN_FUTURE, 'days')) {
      return 2
    } else if (valueState < moment('01/01/1970')) {
      return 3
    } else {
      return 0
    }
  }

  validateCheckDates(data: any[]) {
    _.forEach(data, (o) => {
      let valid = this.validateDate(o.Check_CheckDate)
      if (valid !== 0) {
        o.disabled = true
      } else {
        o.disabled = false
      }
    })
    this.statusRollup()
  }

  showDialog() {
    this.display = true
  }

  handleDialogState(state) {
    this.display = false
    if (state) {
     this.postPaymentFilesForDeposit()
    }
  }

  private updateNotify() {
    if (this.authorizationService.waitUntilReady()) {
      this.authorizationService.HealthcareTopBar.notifyActivity()
    }
  }

  ngOnInit() {
    this.clientInfoChanged()
  }
}



// WEBPACK FOOTER //
// ./src/app/components/confirm-deposit/confirm-deposit.component.ts